import { Alert, Button, Group, Stack, Text } from "@mantine/core"
import { observer } from "mobx-react-lite"
import { useForm, yupResolver } from "@mantine/form"
import { useEffect, useState } from "react"
import { IconAlertCircle, IconCheck } from "@tabler/icons-react"
import { validationSchema } from "./config"
import { TextEditor } from "../../entities/textEditor"
import { AboutStore } from "../../app/store"
import { type AboutOrganizationRequest } from "../../shared/types/aboutOrganization"

// ----------------------------------------------------------------------

export const AboutEditForm = observer(function AboutEditForm() {
  const { loadData, updatePageData, error } = AboutStore
  const [ initialTextContent, setInitialTextContent ] = useState<string>("")
  const [ isSuccess, setIsSuccess ] = useState<boolean>(false)

  const form = useForm<AboutOrganizationRequest>({
    validateInputOnChange: true,
    validate: yupResolver(validationSchema),
    initialValues: {
      textContent: "",
    },
  })

  useEffect(() => {
    void loadData("aboutOrganization").then((aboutOrganizationData) => {
      if (aboutOrganizationData) {
        setInitialTextContent(aboutOrganizationData.textContent)
        form.setValues({ textContent: aboutOrganizationData.textContent })
        form.resetDirty({ textContent: aboutOrganizationData.textContent })
      }
    })

    return () => {
      form.reset()
      setIsSuccess(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = (values: typeof form.values) => {
    void updatePageData("aboutOrganization", values).then(success => {
      if (success) {
        setIsSuccess(true)
      }
    })
  }

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack spacing={0}>
        <Text size="sm">
          Текст статьи
        </Text>
        <TextEditor
          initialValue={initialTextContent}
          placeholder="Напишите здесь текст для страницы об организации"
          {...form.getInputProps("textContent")}
        />
      </Stack>

      {error && (
        <Alert mt="xl" icon={<IconAlertCircle size="1rem"/>} title="Произошла ошибка" color="red">
          {error}
        </Alert>
      )}

      {isSuccess && (
        <Alert mt="xl" icon={<IconCheck size="1rem"/>} title="Успех!" color="green">
          Данные страницы об организации успешно обновлены.
        </Alert>
      )}

      <Group position="center" my="xl">
        <Button disabled={!form.isDirty() || !form.isValid()} type="submit">
          Обновить
        </Button>
      </Group>
    </form>
  )
})
